import { render, staticRenderFns } from "./configuration-list-sidepanel.vue?vue&type=template&id=279a3706&scoped=true&"
import script from "./configuration-list-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./configuration-list-sidepanel.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-list-sidepanel.scss?vue&type=style&index=0&id=279a3706&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a3706",
  null
  
)

export default component.exports